export default {"src":"/_next/static/media/assistant_logo.ef335a27.svg","height":41,"width":150,"blurWidth":0,"blurHeight":0};